import { useState } from "react";
import InfiniteScroll from 'react-infinite-scroller';
import { useParams } from "react-router-dom";
import Title from '../components/Title';
import PostShort from "../components/news/posts/PostShort";
import Categories from "../components/news/widgets/Categories";
import RecentNews from "../components/news/widgets/RecentNews";
import useCache from '../hooks/use-cache';
import useCategories from "../hooks/use-categories";
import '../resources/css/post.css';
import { useGetNewsQuery } from '../store';

export default function NewsByCategoryPage() {

    const [pageIdentifier, setPageIdentifier] = useState(0);
    const [posts, setPosts] = useState([]);
    const [category, setCategory] = useState();

    const { id } = useParams();
    const cacheKey = `news-${id}-${pageIdentifier}`;
    const results = useCache(cacheKey, useGetNewsQuery, { id, pageIdentifier });

    const categories = useCategories();
    const title = categories[id];

    const loadMorePosts = function () {
        if (posts?.length > 0) {
            const lastPost = posts[posts.length - 1];
            setPageIdentifier(lastPost.pageId);
        }
    }

    if (category !== id) {
        setCategory(id);
        setPosts([]);
        setPageIdentifier(0);
        return;
    }

    const newPosts = results.data || [];
    const postsToAdd = newPosts.filter(np => !posts.some(p => p.id === np.id) && (category === 'all' || np.categories.includes(category)));
    if (postsToAdd.length) {
        const newPostsResult = [...posts, ...postsToAdd];

        setPosts(newPostsResult);
        return;
    }

    const postsRendered = posts.map((p) => {
        return <PostShort key={p.id} data={p}></PostShort>
    });

    return (
        <>
            <Title value={title}></Title>

            <div className="news-container">
                <InfiniteScroll loadMore={loadMorePosts} hasMore={true}>
                    {postsRendered}
                </InfiniteScroll>

                <div className="post-widgets">
                    <RecentNews></RecentNews>
                    <Categories></Categories>
                </div>
            </div>
        </>
    );
};